var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 35,
    viewBox: "0 0 21 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4376 13.4995H13.8751V8.12451C13.8751 6.64101 15.0511 6.78076 16.5001 6.78076H19.1251V0.0620117H13.8751C9.52544 0.0620117 6.00006 3.67132 6.00006 8.12451V13.4995H0.750061V20.2183H6.00006V34.9995H13.8751V20.2183H17.8126L20.4376 13.4995Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.556c0deceb4667acc4be4f2f80f93c87.svg";
export { ForwardRef as ReactComponent };